import { render } from "./MemberSyncReview.vue?vue&type=template&id=5ed7dd75&scoped=true"
import script from "./MemberSyncReview.vue?vue&type=script&lang=js"
export * from "./MemberSyncReview.vue?vue&type=script&lang=js"

import "./MemberSyncReview.vue?vue&type=style&index=0&id=5ed7dd75&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed7dd75"]])

export default __exports__